import React from 'react';
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, Role } from '@shared/hooks/useAuthStore';
import { canAccessBackoffice, hasNavAccess, landingPathForRole } from '@shared/utils/roleAccess';

interface Props {
  children: ReactNode;
  roles?: Role[];
}

export function ProtectedRoute({ children, roles }: Props): React.ReactElement {
  const location = useLocation();
  const { token, user } = useAuthStore();
  if (!token || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // BO-18: sessione persistita (tc-auth) di un FAN o ruolo senza BO → al login
  // col messaggio (che fa logout), invece del rimbalzo infinito su '/'.
  if (!canAccessBackoffice(user.role)) {
    return <Navigate to="/login" replace state={{ denied: true }} />;
  }

  // Gerarchia applicata (Admin/Dev includono gli specialisti). Chi non ha accesso
  // viene rimandato alla propria pagina di atterraggio, non a '/' (che potrebbe
  // essere anch'essa vietata e creare un rimbalzo).
  if (roles && roles.length > 0 && !hasNavAccess(user.role, roles)) {
    return <Navigate to={landingPathForRole(user.role)} replace />;
  }

  return <>{children}</>;
}
